import React from "react";
import {IconGithub} from "../icons/icon-github";

export const Senses: React.FC = () => (
  <section className="mt-2 items-center gap-2 hidden md:flex">
    <a href="//github.com/kai0310" rel="noreferrer" target="_blank" className="fill-current text-red-100 hover:bg-black">
      <IconGithub />
    </a>
  </section>
);
